import { z } from 'zod';

export const TransactionStatusSchema = z.enum([
  'success',
  'waiting_for_approval',
  'pending',
  'failed',
]);
export type TransactionStatus = z.infer<typeof TransactionStatusSchema>;
